import { FolderOpen } from "lucide-react";
import { FilesManager } from "@/components/docs/FilesManager";

export default function CorporateFiles() {
  return (
    <main className="px-6 md:px-10 py-8" data-testid="corporate-files-page">
      <header className="mb-6">
        <div className="text-[11px] font-semibold uppercase tracking-widest text-slate-500 inline-flex items-center gap-1.5"><FolderOpen className="h-3.5 w-3.5" /> Documents</div>
        <h1 className="font-display text-2xl font-bold tracking-tight text-slate-900">District files</h1>
        <p className="text-sm text-slate-500">Folders and documents here are visible (read-only) to admins, officers and teachers at every school in your district.</p>
      </header>
      <FilesManager defaultScope="corporate" />
    </main>
  );
}
